// ============================================================
// Loomexra Shopify Theme — theme.js
// Wired to Shopify Ajax Cart API (/cart/add.js, /cart/change.js, /cart.js)
// Wishlist kept client-side (localStorage) — no native Shopify equivalent.
// ============================================================

const qs = (sel, ctx = document) => ctx.querySelector(sel);
const qsa = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

let wishlist = JSON.parse(localStorage.getItem('lx_wishlist') || '[]');

function persistWishlist() {
  localStorage.setItem('lx_wishlist', JSON.stringify(wishlist));
}

function isWishlisted(id) {
  return wishlist.includes(String(id));
}

function toggleWishlist(id) {
  id = String(id);
  if (isWishlisted(id)) wishlist = wishlist.filter(x => x !== id);
  else wishlist.push(id);
  persistWishlist();
  updateWishlistBadge();
}

function updateWishlistBadge() {
  const wc = qs('#wishlist-count');
  if (!wc) return;
  wc.textContent = wishlist.length;
  wc.style.display = wishlist.length ? 'flex' : 'none';
}

function fmtMoney(cents) {
  // Shopify money is stored in the shop's currency; this assumes INR-style whole-unit display.
  return (window.Shopify && window.Shopify.formatMoney)
    ? window.Shopify.formatMoney(cents, window.theme_money_format)
    : '₹' + (cents / 100).toLocaleString('en-IN');
}

// ── Toast ─────────────────────────────────────────────────
function showToast(msg) {
  const tc = qs('#toast-container');
  if (!tc) return;
  const t = document.createElement('div');
  t.className = 'toast';
  t.innerHTML = `<span class="toast-icon">✓</span>${msg}`;
  tc.appendChild(t);
  setTimeout(() => {
    t.classList.add('out');
    t.addEventListener('animationend', () => t.remove(), { once: true });
  }, 3200);
}

// ── Cart (Ajax API) ──────────────────────────────────────
async function ajaxAddToCart(variantId, quantity = 1) {
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity }] })
    });
    if (!res.ok) {
      const err = await res.json();
      showToast(err.description || 'Could not add to cart');
      return null;
    }
    showToast('Added to your bag');
    await refreshCartDrawer();
    return await res.json();
  } catch (e) {
    showToast('Something went wrong. Please try again.');
    return null;
  }
}

async function fetchCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

async function ajaxChangeLine(line, quantity) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line, quantity })
  });
  await refreshCartDrawer();
  if (qs('.cart-page')) window.location.reload();
}

async function refreshCartDrawer() {
  const cart = await fetchCart();
  const cc = qs('#cart-count');
  if (cc) cc.textContent = cart.item_count;

  const wrap = qs('#cart-drawer-items');
  const subtotalEl = qs('#cart-drawer-subtotal');
  if (!wrap) return;

  if (cart.items.length === 0) {
    wrap.innerHTML = '<p class="empty-state" style="padding:30px 0;">Your bag is empty.</p>';
  } else {
    wrap.innerHTML = cart.items.map((item, i) => `
      <div class="cart-line" data-line="${i + 1}">
        <a href="${item.url}" class="cart-line-img"><img src="${item.image}" alt="${item.product_title}"></a>
        <div class="cart-line-info">
          <a href="${item.url}" class="cart-line-name">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-line-variant">${item.variant_title}</div>` : ''}
          <div class="cart-line-price">${fmtMoney(item.final_price)}</div>
          <div class="qty-control">
            <button type="button" class="qty-btn" data-drawer-qtydec="${i + 1}">&minus;</button>
            <span class="qty-display">${item.quantity}</span>
            <button type="button" class="qty-btn" data-drawer-qtyinc="${i + 1}">+</button>
          </div>
        </div>
        <button type="button" class="cart-line-remove" data-drawer-remove="${i + 1}" aria-label="Remove"><i data-lucide="trash-2"></i></button>
      </div>
    `).join('');
  }
  if (subtotalEl) subtotalEl.textContent = fmtMoney(cart.total_price);
  if (window.lucide) lucide.createIcons();
}

// ── Quick View Modal ──────────────────────────────────────
let qvState = { product: null, selectedVariant: null };

function openQuickView(productJSON) {
  const p = productJSON;
  qvState.product = p;
  qvState.selectedVariant = p.variants.find(v => v.available) || p.variants[0];

  qs('#qv-img').src = (p.featured_image || (p.images && p.images[0])) + '';
  qs('#qv-img').alt = p.title;
  qs('#qv-rating').textContent = '';
  qs('#qv-rating').closest('.modal-rating').style.display = 'none';
  qs('#qv-name').textContent = p.title;
  qs('#qv-price').textContent = fmtMoney(qvState.selectedVariant.price);

  const tmp = document.createElement('div');
  tmp.innerHTML = p.description || '';
  qs('#qv-desc').textContent = (tmp.textContent || '').slice(0, 220);

  qs('#qv-highlights').innerHTML = '';

  const sizeOptionIndex = p.options ? p.options.findIndex(o => /size/i.test(o)) : -1;
  const sizes = sizeOptionIndex >= 0 ? [...new Set(p.variants.map(v => v['option' + (sizeOptionIndex + 1)]))] : [];

  qs('#qv-sizes').innerHTML = sizes.map((s, i) =>
    `<button class="sz-pill${i === 0 ? ' active' : ''}" data-qvs="${s}">${s}</button>`
  ).join('');

  const wished = isWishlisted(p.id);
  const wishBtn = qs('#qv-wish');
  wishBtn.className = `modal-wish-btn ${wished ? 'active' : ''}`;
  wishBtn.innerHTML = wished
    ? '<i data-lucide="heart" style="fill:#C0645A;color:#C0645A;"></i>'
    : '<i data-lucide="heart"></i>';

  qs('#qv-overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
  if (window.lucide) lucide.createIcons();

  qs('#qv-sizes').onclick = (e) => {
    const sp = e.target.closest('[data-qvs]');
    if (!sp) return;
    qsa('#qv-sizes .sz-pill').forEach(x => x.classList.remove('active'));
    sp.classList.add('active');
    const chosenSize = sp.dataset.qvs;
    const match = p.variants.find(v => v['option' + (sizeOptionIndex + 1)] === chosenSize && v.available);
    if (match) {
      qvState.selectedVariant = match;
      qs('#qv-price').textContent = fmtMoney(match.price);
    }
  };

  qs('#qv-atc').onclick = async () => {
    await ajaxAddToCart(qvState.selectedVariant.id, 1);
    closeQuickView();
  };

  wishBtn.onclick = () => {
    toggleWishlist(p.id);
    const wl = isWishlisted(p.id);
    wishBtn.className = `modal-wish-btn ${wl ? 'active' : ''}`;
    wishBtn.innerHTML = wl
      ? '<i data-lucide="heart" style="fill:#C0645A;color:#C0645A;"></i>'
      : '<i data-lucide="heart"></i>';
    if (window.lucide) lucide.createIcons();
  };
}

function closeQuickView() {
  qs('#qv-overlay').classList.remove('open');
  document.body.style.overflow = '';
}

// ── Mobile Drawer ─────────────────────────────────────────
function openMobileDrawer() {
  qs('#mobile-drawer').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeMobileDrawer() {
  qs('#mobile-drawer').classList.remove('open');
  document.body.style.overflow = '';
}

// ── Init ──────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  if (window.lucide) lucide.createIcons();
  updateWishlistBadge();
  qsa('.wish-btn[data-wish]').forEach(btn => {
    if (isWishlisted(btn.dataset.wish)) btn.classList.add('active');
  });

  // Mobile drawer
  qs('#hamburger-btn')?.addEventListener('click', openMobileDrawer);
  qs('#drawer-close')?.addEventListener('click', closeMobileDrawer);
  qs('#drawer-backdrop')?.addEventListener('click', closeMobileDrawer);

  // Category dropdown (desktop hover/click)
  const catTrigger = qs('#cat-nav-trigger');
  const catDropdown = qs('#category-dropdown');
  if (catTrigger && catDropdown) {
    catTrigger.parentElement.addEventListener('mouseenter', () => catDropdown.classList.add('open'));
    catTrigger.parentElement.addEventListener('mouseleave', () => catDropdown.classList.remove('open'));
  }

  // Quick view modal close
  qs('#qv-overlay')?.addEventListener('click', e => {
    if (e.target.id === 'qv-overlay') closeQuickView();
  });
  qs('#qv-close')?.addEventListener('click', closeQuickView);

  // Cart drawer
  qs('#cart-btn')?.addEventListener('click', (e) => {
    e.preventDefault();
    qs('#cart-drawer-overlay')?.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  });
  qs('#cart-drawer-close')?.addEventListener('click', () => {
    qs('#cart-drawer-overlay')?.classList.remove('open');
    document.body.style.overflow = '';
  });
  qs('#cart-drawer-overlay')?.addEventListener('click', e => {
    if (e.target.id === 'cart-drawer-overlay') {
      qs('#cart-drawer-overlay').classList.remove('open');
      document.body.style.overflow = '';
    }
  });

  // Delegated: product card interactions (works across dynamically rendered grids)
  document.addEventListener('click', async (e) => {
    // Quick view trigger
    const qvBtn = e.target.closest('[data-qv]');
    if (qvBtn) {
      e.preventDefault();
      try {
        const productJSON = JSON.parse(qvBtn.dataset.qvJson);
        openQuickView(productJSON);
      } catch (err) { console.error('Quick view parse error', err); }
      return;
    }

    // Add to cart from product card
    const atcBtn = e.target.closest('[data-atc]');
    if (atcBtn && atcBtn.dataset.variantId) {
      e.preventDefault();
      await ajaxAddToCart(atcBtn.dataset.variantId, 1);
      return;
    }

    // Wishlist toggle from card
    const wishBtn = e.target.closest('[data-wish]');
    if (wishBtn) {
      e.preventDefault();
      toggleWishlist(wishBtn.dataset.wish);
      wishBtn.classList.toggle('active', isWishlisted(wishBtn.dataset.wish));
      return;
    }

    // Cart drawer line qty / remove
    const dec = e.target.closest('[data-drawer-qtydec]');
    if (dec) { const cart = await fetchCart(); const line = +dec.dataset.drawerQtydec; const item = cart.items[line - 1]; if (item) await ajaxChangeLine(line, Math.max(0, item.quantity - 1)); return; }

    const inc = e.target.closest('[data-drawer-qtyinc]');
    if (inc) { const cart = await fetchCart(); const line = +inc.dataset.drawerQtyinc; const item = cart.items[line - 1]; if (item) await ajaxChangeLine(line, item.quantity + 1); return; }

    const rem = e.target.closest('[data-drawer-remove]');
    if (rem) { await ajaxChangeLine(+rem.dataset.drawerRemove, 0); return; }

    // Cart page qty / remove (server-rendered, uses .qty-val display)
    const pageDec = e.target.closest('[data-qtydec]');
    if (pageDec) {
      const line = +pageDec.dataset.qtydec;
      const cart = await fetchCart();
      const item = cart.items[line - 1];
      if (item) await ajaxChangeLine(line, Math.max(0, item.quantity - 1));
      return;
    }

    const pageInc = e.target.closest('[data-qtyinc]');
    if (pageInc) {
      const line = +pageInc.dataset.qtyinc;
      const cart = await fetchCart();
      const item = cart.items[line - 1];
      if (item) await ajaxChangeLine(line, item.quantity + 1);
      return;
    }

    const pageRemove = e.target.closest('[data-remove]');
    if (pageRemove) { await ajaxChangeLine(+pageRemove.dataset.remove, 0); return; }
  });

  // Product page: size pill -> variant select
  const pdForm = qs('#pd-form');
  if (pdForm) {
    const variantSelect = qs('#pd-variant-id');
    qsa('.sz-pill[data-option-index]', pdForm).forEach(pill => {
      pill.addEventListener('click', () => {
        qsa(`.sz-pill[data-option-index="${pill.dataset.optionIndex}"]`, pdForm).forEach(x => x.classList.remove('active'));
        pill.classList.add('active');
        // naive: matches on the value text within any variant option matching the value
        const match = [...variantSelect.options].find(o => o.text.includes(pill.dataset.value));
        if (match) variantSelect.value = match.value;
      });
    });

    // Product page wishlist
    qs('#pd-wish')?.addEventListener('click', () => {
      const id = qs('#pd-wish').dataset.wish;
      toggleWishlist(id);
      qs('#pd-wish').classList.toggle('active', isWishlisted(id));
    });
  }
});
